import { initializeApp } from 'firebase/app';
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence,
  initializeAuth,
} from 'firebase/auth';
import { config } from './config';

export const firebaseApp = initializeApp(config.firebase);

/**
 * localStorage goes first: mobile browsers close IndexedDB connections of backgrounded/frozen tabs,
 * which makes Firebase Auth fail with "The database connection is closing"
 * (https://github.com/firebase/firebase-js-sdk/issues/2710).
 * IndexedDB stays in the list so that sessions persisted there are migrated to localStorage on startup.
 */
export const auth = initializeAuth(firebaseApp, {
  persistence: [browserLocalPersistence, indexedDBLocalPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});
